export type WidgetEventHandlers = {
  onImmediate?(): void;
  onMount?(): void;
  onOpen?(): void;
  onClose?(): void;
  onLinkClick?(): void;
  onButtonClick?(a: { label: string }): void;
};

export interface WidgetConfigurationCustomize {
  floatingIcon: {
    color?: string;
    size?: { width: number; height: number };
    src?: string;
    position: 'left-bottom' | 'right-bottom';
    distanceFromScreenEdges?: { x: number; y: number };
  };
  messages?: {
    headerText?: string;
    balloonText?: string;
  };
  themeColor: string;
  icons?: {
    bot?: string;
    customer?: string;
    operator?: string;
  };
  floatingChatWindowHeight?: number;
  enableInputMasking?: boolean;
  miniFloatIconColor?: string;
}

export interface WidgetWhitelist {
  acceptDomains?: string[];
  acceptUrl?: string[];
}
export interface WidgetConfiguration {
  whitelist: WidgetWhitelist;
  customization: WidgetConfigurationCustomize;
  events?: { [P in keyof WidgetEventHandlers]?: [string, string] };
}

export const defaultWidgetConfiguration: WidgetConfiguration = {
  whitelist: {
    acceptUrl: ['https://*ai-messenger.app'],
  },
  customization: {
    floatingIcon: {
      position: 'right-bottom',
      distanceFromScreenEdges: { x: 0, y: 0 },
    },
    messages: {
      balloonText: 'ようこそ',
      headerText: 'チャットサポート',
    },
    themeColor: '#0066FF',
    floatingChatWindowHeight: undefined,
    enableInputMasking: false,
  },
};

export const mergeCustomization = (
  a: WidgetConfigurationCustomize = defaultWidgetConfiguration.customization,
  b?: WidgetConfigurationCustomize
): WidgetConfigurationCustomize => {
  const defaultSize = { width: 100, height: 100 };
  return {
    floatingIcon: {
      ...(b?.floatingIcon ?? a.floatingIcon),
      size: {
        ...(b?.floatingIcon?.size ?? a.floatingIcon.size ?? defaultSize),
      },
      distanceFromScreenEdges: {
        ...(b?.floatingIcon?.distanceFromScreenEdges ??
          a.floatingIcon.distanceFromScreenEdges ?? { x: 0, y: 0 }),
      },
    },
    messages: {
      ...(b?.messages ?? a.messages ?? {}),
    },
    themeColor: b?.themeColor ?? a.themeColor,
    icons: {
      ...(b?.icons ?? a.icons ?? {}),
    },
    floatingChatWindowHeight: b?.floatingChatWindowHeight ?? a.floatingChatWindowHeight,
    miniFloatIconColor: b?.miniFloatIconColor ?? a.miniFloatIconColor,
  };
};
